export default "__VITE_ASSET__CbVVpqmI__"